<div class="main-container">

  <div class="title">
    <span class="title-text">Search Requisitions</span>
    <p class="small-title">Locate a requisition by ID or Aadhaar.</p>
  </div>

  <div class="searchBar">
    <div class="each-div small">
      <span class="drop-title">Search by</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="searchType">
          <mat-option [value]="'aadhaar'">Aadhaar</mat-option>
          <mat-option [value]="'id'">Booking ID</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="each-div">
      <span class="drop-title">Value</span>
      <input type="text" class="text-box-active" [formControl]="searchValue" />
    </div>

    <div class="btn">
      <button type="button" class="ac-primary-btn" (click)="search()">Search</button>
    </div>
  </div>

  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Booking ID</th>
          <th>Family Code</th>
          <th>Category</th>
          <th>Type</th>
          <th>Mode</th>
          <th>Guests</th>
          <th>From</th>
          <th>To</th>
          <th>Status</th>
          <th>Stage</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(row of results; track row.requisitionId){
        <tr>
          <td>{{ row.requisitionId }}</td>
          <td>{{ row.familyCode }}</td>
          <td>{{ row.requisitionCategory || '-' }}</td>
          <td>{{ row.requisitionType || '-' }}</td>
          <td>{{ row.requisitionMode || '-' }}</td>
          <td>{{ row.requisitionGuestCount }}</td>
          <td>{{ row.requisitionFromDate }}</td>
          <td>{{ row.requisitionToDate }}</td>
          <td>{{ row.requisitionStatus }}</td>
          <td>{{ row.requisitionLifecycleStatus }}</td>
          <td class="actions-cell">
            <button type="button" class="ac-secondary-small-btn" (click)="downloadSlip(row)">Booking slip PDF</button>
          </td>
        </tr>
        }
        @if(hasSearched && results.length === 0){
        <tr>
          <td colspan="11" class="empty-row">No requisitions found.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
